/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import { useEffect, useState } from 'react'
import { DraggableList } from './DraggableList'
import { useDeviceMediaQuery } from '../../../Shared/UseDeviceMediaQuery/useDeviceMediaQuery'
import { useQueryClient } from '@tanstack/react-query'
import useUser from '../../../Shared/UserProvider/useUser'
import { getAislesNotInPickingPath } from './usePickingPath'

const AisleDetail = ({aisle, onUpdate}) => {
    const [currentAisle, setCurrentAisle] = useState(aisle)
    const {isMobile} = useDeviceMediaQuery()
    const {user} = useUser()
    const queryClient = useQueryClient()

    const allAisles = queryClient.getQueryData(['providers', user.provider.id, 'aisles'])

    useEffect(() => {
        setCurrentAisle(aisle)
    }, [aisle])

    const handleSubAislesChange = (newSubAisles) => {
        const updatedAisle = {
            ...currentAisle,
            aisles: newSubAisles,
        }

        setCurrentAisle(updatedAisle)

        if (onUpdate) {
            onUpdate(newSubAisles)
        }
    }

    if (!allAisles || !currentAisle.aisles) return []
    const currentAislePart = allAisles.find(a => a.id === aisle.id) || []
    const withdrawnAisles = getAislesNotInPickingPath(currentAislePart.aisles, aisle.aisles)

    return (
      <div css={css`
          margin-top: 2rem;
          padding: ${isMobile ? '0.5rem' : '1rem'};
      `}>
          <DraggableList
            pickingPath={currentAisle.aisles || []}
            withdrawnAisles={withdrawnAisles}
            onChange={handleSubAislesChange}
          />
      </div>
    )
}

export { AisleDetail }
